const domHelper = {
  resetWindowScroll: () => window.scrollTo(0, 0),
};

export { domHelper };
